module.exports = __webpack_public_path__ + "assets/person-black-f024dc36a0f3b18aa599ef8c7a2a7fd1.svg";